export default __webpack_public_path__ + "images/empty_bottle.png";